import { createSlice } from "@reduxjs/toolkit";
import Cookies from "js-cookie";

const initialState = {
  userId: Cookies.get("userId") ? Cookies.get("userId") : null,
  token: Cookies.get("token") ? Cookies.get("token") : null,
  role: Cookies.get("role") ? Cookies.get("role") : null,
  empId: Cookies.get("empId") ? Cookies.get("role") : null,
  workGroups: Cookies.get("workGroups") ? Cookies.get("workGroups") : [],
};

export const user_information = createSlice({
  name: "user",
  initialState,
  reducers: {
    setLoginData(state, action) {
      state.userId = action.payload || null;
      Cookies.set("userId", state.userId);
    },
    loginSuccess: (state, action) => {
        state.token = action.payload.token;
        state.role = action.payload.role;
        state.empId=action.payload.empId;
        // Store in cookies
        Cookies.set("token", state.token);
        Cookies.set("role", state.role);
      localStorage.setItem("empRole", state.empId);
        // Store in localStorage for direct access
        localStorage.setItem("role", state.role);
      },
      
    logout: (state) => {
      state.userId = null;
      state.token = null;
      state.role = null;
      Cookies.set("token", state.token);
      Cookies.set("role", state.role);
      Cookies.set("userId", state.userId);
    },
     setWorkGroupsRedux: (state, action) => {
      state.workGroups = action.payload;
      console.log("action.payload : ",action.payload)
      Cookies.set("workGroups", state.workGroups);
    },
  },
});

export const { setLoginData, logout,loginSuccess,setWorkGroupsRedux } = user_information.actions;
export default user_information.reducer;
